import styles from './ContactPage.module.css';

function ContactPage() {
  return (
    <div className={styles.page}>
      <section className={styles.content}>
        <h1 className={styles.title}>Contact Beantown</h1>
        <h3 className={styles.label}>Call</h3>
        <h2 className={styles.value}>617-426-0111</h2>
        <h3 className={styles.label}>Mailing Address</h3>
        <h2 className={styles.value}>100 Tremont Street<br />Boston MA, 02108</h2>
        <h3 className={styles.label}>Email</h3>
        <h4 className={styles.email}>BeantownPubBoston@gmail.com</h4>
        <p className={styles.legal}>Bosworth Place Inc. Beantown Pub DBA</p>
      </section>
    </div>
  );
}

export default ContactPage;
